const DAY_MS = 86400000

export function validDateKey(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '') || value.startsWith('0000')) return false
  const date = new Date(`${value}T12:00:00Z`)
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value
}

export function addDateDays(value, amount) {
  if (!validDateKey(value) || !Number.isInteger(amount)) return ''
  const date = new Date(`${value}T12:00:00Z`)
  date.setUTCDate(date.getUTCDate() + amount)
  return date.getUTCFullYear() >= 1 && date.getUTCFullYear() <= 9999 ? date.toISOString().slice(0, 10) : ''
}

export function monthRange(value) {
  if (!/^\d{4}-\d{2}$/.test(value || '')) return null
  const [year, month] = value.split('-').map(Number)
  if (year < 1 || month < 1 || month > 12) return null
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
  const count = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1]
  return { date_from: `${value}-01`, date_to: `${value}-${count}` }
}

export function monthLeadingDays(value) {
  const range = monthRange(value)
  return range ? (new Date(`${range.date_from}T12:00:00Z`).getUTCDay() + 6) % 7 : 0
}

export function calendarDateLabel(value) {
  if (!validDateKey(value)) return '—'
  return new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(`${value}T12:00:00Z`))
}

function validTime(value) {
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(value || '')
}

function localMoment(value) {
  return typeof value === 'string' && value.length === 16 && validDateKey(value.slice(0, 10)) && value[10] === 'T' && validTime(value.slice(11))
}

export function validateAvailabilityPeriod(form) {
  if (!localMoment(form.startsAt) || !localMoment(form.endsAt)) return 'Укажите начало и окончание периода.'
  if (form.endsAt <= form.startsAt) return 'Окончание должно быть позже начала.'
  if (new Date(`${form.endsAt}:00Z`) - new Date(`${form.startsAt}:00Z`) > 31 * DAY_MS) return 'Один поиск ограничен 31 днём.'
  if (form.guests !== '' && form.guests != null && (!/^\d+$/.test(String(form.guests)) || Number(form.guests) < 1 || Number(form.guests) > 2147483647)) return 'Количество гостей должно быть положительным целым числом.'
  return ''
}

export function availabilityPeriodParams(form) {
  return {
    starts_at: form.startsAt,
    ends_at: form.endsAt,
    ...(form.resourceType ? { resource_type: form.resourceType } : {}),
    ...(form.guests !== '' && form.guests != null ? { guests: Number(form.guests) } : {}),
  }
}

export function validateObjectAvailability(form) {
  if (!form.resourceId) return 'Выберите объект.'
  if (!monthRange(form.month)) return 'Выберите месяц.'
  if (!validTime(form.startTime) || !validTime(form.endTime)) return 'Укажите время начала и окончания.'
  if (!/^\d+$/.test(String(form.endDayOffset)) || Number(form.endDayOffset) > 30) return 'Дней до окончания: целое число от 0 до 30.'
  if (Number(form.endDayOffset) === 0 && form.endTime <= form.startTime) return 'Для окончания в тот же день время должно быть позже начала.'
  const range = monthRange(form.month)
  if (!addDateDays(range.date_to, Number(form.endDayOffset))) return 'Окончание выходит за допустимый диапазон дат.'
  return ''
}

export function objectAvailabilityParams(form) {
  return {
    ...monthRange(form.month),
    start_time: form.startTime,
    end_time: form.endTime,
    end_day_offset: Number(form.endDayOffset),
  }
}

export function availabilityBooking(resourceId, period) {
  if (!Number.isInteger(Number(resourceId)) || Number(resourceId) < 1 || !period?.starts_at || !period?.ends_at) return null
  const start = Date.parse(period.starts_at)
  const end = Date.parse(period.ends_at)
  if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end) return null
  return { resourceId: Number(resourceId), startsAt: period.starts_at, endsAt: period.ends_at }
}

export function freeResourceBooking(result, resourceId) {
  const resource = result?.resources?.find((row) => String(row.id) === String(resourceId) && row.available === true)
  const candidate = resource ? availabilityBooking(resource.id, result) : null
  return candidate ? { ...candidate, resource } : null
}

export function freeDateBooking(result, date) {
  const day = result?.days?.find((row) => row.date === date && row.available === true)
  const candidate = day ? availabilityBooking(result.resource?.id, day) : null
  return candidate ? { ...candidate, resource: result.resource } : null
}
